import React from 'react';
import { PageBuilder } from './components/PageBuilder';

const App = () => <PageBuilder />;

export default App;



// WEBPACK FOOTER //
// ./src/App.js